// Garde-fou anti open-redirect : n'accepte qu'un chemin interne absolu
// (« /library », « /share/xxx »). Rejette les URLs absolues (« //evil.com »,
// « https://… ») et tout ce qui n'est pas un chemin app. Retombe sur `/library`.
export function safeNext(next: string | null | undefined, fallback = '/library'): string {
  if (!next) return fallback;
  // Doit commencer par un seul « / » (pas « // » qui vaut protocol-relative).
  if (!next.startsWith('/') || next.startsWith('//')) return fallback;
  // Pas d'espace ni de saut de ligne (anti-injection). Les tirets sont OK
  // (UUID de souvenirs : /memory/481c3506-4285-…).
  if (/\s/.test(next)) return fallback;
  return next;
}
